import * as React from 'react'
import classNames from 'classnames'
import './changeTag.scss'
import { useTranslation } from 'translations'

export type ChangeTagKind = 'new' | 'changed' | 'removing' | 'notSaved'

interface ChangeTagProps {
    kind: ChangeTagKind
    className?: string
}

export function ChangeTag({ kind, className }: ChangeTagProps) {
    const { t } = useTranslation()
    return <span className={classNames('change-tag', kind, className)}>{t(`capacity.products.tags.${kind}`)}</span>
}
